import { BasicReference } from "./BasicReference.js";
/**
 * Creates a observable reference with an initial value.
 *
 * @param initialValue The initial value of the ref.
 * @param onUpdate A callback that is called when the ref value is updated.
 *
 * @remarks
 *
 * The `onUpdate` callback is referenced strongly by the ref object,
 * but update subscriptions are weakly referenced to prevent memory leaks.
 *
 * @public
 *
 * @example
 *
 * ```ts
 * const num$ = ref(0);
 * ```
 */
export function createReference(initialValue, arg1) {
    let options;
    if (typeof arg1 === "function") {
        options = { initialValue, onUpdate: arg1 };
    }
    else {
        options = { ...arg1, initialValue };
    }
    return new BasicReference(options);
}
(function (createReference) {
    function from(arg0, arg1, arg2) {
        if (
        // We have to check the length and not the existence of `arg1` because,
        // because `arg1` can be `undefined`, which is a valid value for the
        // `initialValue` parameter.
        arguments.length === 1) {
            const initialValue = arg0;
            return (observable) => {
                return createReference.from(observable, initialValue);
            };
        }
        const observable = arg0;
        const initialValue = arg1;
        const updateHandlerOrOptions = arg2;
        const reference = createReference(initialValue, updateHandlerOrOptions);
        const subscription = observable.subscribe(reference);
        return Object.assign(reference, { subscription });
    }
    createReference.from = from;
})(createReference || (createReference = {}));
export { 
// `ref` is an alias for `createReference` for brevity.
// `createReference` is retained for clarity and to avoid naming collisions.
createReference as ref, };
